import SA from 'scroll-animations-js';
import $ from "jquery";
//import AOS from 'aos';
//import {gsap} from "gsap";
//import {ScrollTrigger} from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';
import "owl.carousel";
import axios from "axios";
import mask from "jquery-mask-plugin";

//locomotiveScroll = new LocomotiveScroll();

const owl = jQuery('.topo-slider .owl-carousel').owlCarousel({
    nav:false,
    dots:true,
    items:1,
    loop:true,
    autoplay:true,
    autoplayTimeout:7000,
    autoplayHoverPause:true
});


const owl_products = jQuery('.owl-carousel.owl-products').owlCarousel({
    loop:true,
    margin:32,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
});

const owl_sobre = jQuery('.owl-carousel.owl-sobre').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    center: true,
    navText: [
        `
            <svg width="47" height="45" viewBox="0 0 47 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="23.5001" cy="22.5" rx="22.5116" ry="22" transform="rotate(-180 23.5001 22.5)" fill="#3E7565"/>
                <path d="M23.5141 15.8694L17.1822 22.1143C17.0669 22.2331 16.9766 22.3731 16.9163 22.5265C16.7896 22.8305 16.7896 23.1716 16.9163 23.4757C16.9766 23.629 17.0669 23.7691 17.1822 23.8878L23.5141 30.1327C23.6322 30.2491 23.7724 30.3415 23.9266 30.4045C24.0809 30.4676 24.2462 30.5 24.4132 30.5C24.7505 30.5 25.0739 30.3679 25.3124 30.1327C25.5508 29.8975 25.6848 29.5785 25.6848 29.2459C25.6848 28.9133 25.5508 28.5943 25.3124 28.3592L21.1333 24.25L30.7451 24.25C31.081 24.25 31.4031 24.1184 31.6406 23.8842C31.8781 23.65 32.0115 23.3323 32.0115 23.0011C32.0115 22.6698 31.8781 22.3521 31.6406 22.1179C31.4031 21.8837 31.081 21.7521 30.7451 21.7521L21.1333 21.7521L25.3124 17.643C25.4311 17.5269 25.5253 17.3887 25.5896 17.2365C25.6538 17.0843 25.6869 16.9211 25.6869 16.7562C25.6869 16.5913 25.6538 16.4281 25.5896 16.2759C25.5253 16.1237 25.4311 15.9856 25.3124 15.8694C25.1946 15.7524 25.0546 15.6595 24.9002 15.5961C24.7459 15.5326 24.5804 15.5 24.4132 15.5C24.2461 15.5 24.0805 15.5326 23.9262 15.5961C23.7719 15.6595 23.6318 15.7524 23.5141 15.8694Z" fill="white"/>
            </svg>
        `,
        `
            <svg width="47" height="45" viewBox="0 0 47 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="23.4999" cy="22.5" rx="22.5116" ry="22" fill="#3E7565"/>
                <path d="M23.4859 29.1306L29.8178 22.8857C29.9331 22.7669 30.0234 22.6269 30.0837 22.4735C30.2104 22.1695 30.2104 21.8284 30.0837 21.5243C30.0234 21.371 29.9331 21.2309 29.8178 21.1122L23.4859 14.8673C23.3678 14.7509 23.2276 14.6585 23.0734 14.5955C22.9191 14.5324 22.7538 14.5 22.5868 14.5C22.2495 14.5 21.9261 14.6321 21.6876 14.8673C21.4492 15.1025 21.3152 15.4215 21.3152 15.7541C21.3152 16.0867 21.4492 16.4057 21.6876 16.6409L25.8667 20.75L16.2549 20.75C15.919 20.75 15.5969 20.8816 15.3594 21.1158C15.1219 21.35 14.9885 21.6677 14.9885 21.9989C14.9885 22.3302 15.1219 22.6479 15.3594 22.8821C15.5969 23.1163 15.919 23.2479 16.2549 23.2479L25.8667 23.2479L21.6876 27.357C21.5689 27.4731 21.4747 27.6113 21.4104 27.7635C21.3462 27.9157 21.3131 28.0789 21.3131 28.2438C21.3131 28.4087 21.3462 28.5719 21.4104 28.7241C21.4747 28.8763 21.5689 29.0144 21.6876 29.1306C21.8054 29.2476 21.9454 29.3405 22.0998 29.4039C22.2541 29.4674 22.4196 29.5 22.5868 29.5C22.7539 29.5 22.9195 29.4674 23.0738 29.4039C23.2281 29.3405 23.3682 29.2476 23.4859 29.1306Z" fill="white"/>
            </svg>
        `,
    ],
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:3
        }
    }
});

jQuery('.video-relative').click(function() {
    jQuery(this).html("<iframe src='" + jQuery(this).attr('data-video') + "'/>");
})

SA.init({});

// Função para adicionar ou remover a classe 'top' no body
window.onscroll = function () {
    var body = document.body;

    // Se o usuário estiver no topo da página (scrollY == 0), adicionar a classe 'top'
    if (window.scrollY === 0) {
        body.classList.add('top');
    } else {
        body.classList.remove('top');
    }
};

// Ao carregar a página, verifica se está no topo e adiciona a classe 'top' se for o caso
window.onload = function () {
    if (window.scrollY === 0) {
        document.body.classList.add('top');
    }
};

let textLengthArray = [];

function type(index) {
    let paragraph = document.getElementsByClassName("typed")[index];
    let text = paragraph.getAttribute("data-text");
    let textLength = textLengthArray[index];

    if (!textLength) {
        textLength = 0;
        textLengthArray[index] = 0;
        paragraph.innerText = "";
    }

    let textChar = text.charAt(textLength++);
    let charElement = document.createTextNode(textChar);
    paragraph.appendChild(charElement);

    if (textLength < text.length + 1) {
        textLengthArray[index] = textLength;
        setTimeout(() => {
            type(index);
        }, 50);
    }
}

function countUp(index) {
    let counter = document.getElementsByClassName("counter")[index];
    let targetValue = parseFloat(counter.getAttribute("data-target")); // Pode ser float ou int
    let integerPart = Math.floor(targetValue); // Parte inteira
    let decimalPart = targetValue % 1; // Parte decimal
    let currentValue = 0; // Valor inicial
    let increment = 1; // Incremento para a parte inteira

    function countIntegers() {
        if (currentValue < integerPart) {
            currentValue += increment;
            counter.innerText = currentValue; // Atualiza o contador com o valor inteiro
            setTimeout(countIntegers, 50); // Atualiza a cada 50ms
        } else {
            currentValue = integerPart; // Garante o valor final
            counter.innerText = currentValue; // Exibe o valor inteiro final
            if (decimalPart > 0) {
                setTimeout(countDecimals, 50); // Inicia a contagem decimal
            }
        }
    }

    function countDecimals() {
        let decimalCurrent = 0; // Começa do 0 para os decimais
        let decimalIncrement = decimalPart / 10; // Incrementa em etapas menores (0.1, 0.2, ...)

        function updateDecimals() {
            if (decimalCurrent < decimalPart) {
                decimalCurrent += decimalIncrement;

                // Evita ultrapassar o valor decimal
                if (decimalCurrent > decimalPart) {
                    decimalCurrent = decimalPart;
                }

                counter.innerText = `${integerPart}${decimalCurrent.toFixed(1).substring(1)}`; // Atualiza ex: "5.1"
                setTimeout(updateDecimals, 50); // Atualiza a cada 50ms
            } else {
                counter.innerText = targetValue.toFixed(1); // Garante o valor final exato
            }
        }

        updateDecimals();
    }

    countIntegers();
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function checkScroll() {
    let paragraphs = document.querySelectorAll(".typed");
    paragraphs.forEach((paragraph, index) => {
        if (isElementInViewport(paragraph) && !paragraph.classList.contains('started')) {
            paragraph.classList.add('started');
            type(index); // Inicia a animação de digitação
        }
    });

    let counters = document.querySelectorAll(".counter");
    counters.forEach((counter, index) => {
        if (isElementInViewport(counter) && !counter.classList.contains('counted')) {
            counter.classList.add('counted');
            setTimeout(() => {
                countUp(index); // Inicia o count up após um delay
            }, 1000 * index); // Aplica o delay de 300ms por cada índice
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    let paragraphs = document.querySelectorAll(".typed");
    paragraphs.forEach((paragraph, index) => {
        let text = paragraph.innerText;
        paragraph.setAttribute("data-text", text);
    });

    let counters = document.querySelectorAll(".counter");
    counters.forEach(counter => {
        counter.innerText = "0"; // Inicializa os contadores com zero
    });

    window.addEventListener("scroll", checkScroll);
    checkScroll(); // Checa a visibilidade inicial no carregamento da página
});


$(".tabs a").click(function () {
    $("a", $(this).parent()).removeClass("act");
    $(this).addClass("act");
    $('.servico[data-title="' + $(this).attr("data-click-title") + '"]').hide();
    $('.servico[data-id="' + $(this).attr("data-click") + '"][data-title="' + $(this).attr("data-click-title") + '"]').show();
    return false;
});


$(".image-video").click(function () {
    $(this).html(decodeURIComponent($(".image-video").attr("data-embed")));
});


$(document).resize(function () {

})

jQuery('[type="tel"]').mask('(00) 00000-0000');

jQuery(function($){
    $('.cpf_cnpj').mask('000.000.000-000', {
        onKeyPress: function(val, e, field, options) {
            var masks = ['000.000.000-000', '00.000.000/0000-00'];
            var mask = (val.replace(/\D/g, '').length > 11) ? masks[1] : masks[0];
            field.mask(mask, options);
        }
    });
});
function effectsLeft() {
    $(".max-1198");
    $(".max-left-1198");
}

document.addEventListener('DOMContentLoaded', function() {
    const parallaxAssets = document.querySelectorAll('.parallax-asset img');

    // Função para aplicar o efeito parallax a um elemento específico
    function applyParallaxEffect(scrollPosition, element) {
        element.style.transform = 'translateY(' + (scrollPosition * 0.1) + 'px)';
    }

    // Configuração do IntersectionObserver
    const observerOptions = {
        root: null, // Usa o viewport como referência
        threshold: 0.1 // Aciona quando 10% do elemento está em view
    };

    parallaxAssets.forEach(parallaxAsset => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Adiciona o listener de scroll apenas quando o elemento está visível
                    window.addEventListener('scroll', function onScroll() {
                        const scrollPosition = window.scrollY;
                        applyParallaxEffect(scrollPosition, parallaxAsset);
                    });
                }
            });
        }, observerOptions);

        // Observa cada elemento
        observer.observe(parallaxAsset);
    });
});

jQuery(".menu-mobile").click(function () {
    jQuery(this).toggleClass("act");
    jQuery("header .menu-container").toggleClass("act");
    return false;
})

setTimeout(function () {
    jQuery('#quick-message').slideUp(300, function(){
        jQuery(this).remove();
    });
}, 9000);

document.addEventListener('DOMContentLoaded', function() {
    // Seleciona todos os formulários com a classe "submit"
    const forms = document.querySelectorAll('form.submit');

    forms.forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault(); // Impede o envio padrão do formulário

            const formData = new FormData(form); // Cria o FormData a partir do formulário
            const data = {};

            // Converte o FormData para um objeto JavaScript usando o atributo 'name' como chave
            formData.forEach((value, key) => {
                data[key] = value;
            });

            // Estrutura de dados para envio
            const submissionData = {
                to: form.getAttribute("data-to"),
                url: form.getAttribute("data-url"),
                form_name: form.getAttribute("name"),
                form_type: "Contato", // Tipo de serviço
                submission_date: new Date().toISOString(), // Data atual no formato 'YYYY-MM-DD'
                submission_data: JSON.stringify(data), // Converte todos os dados do formulário para JSON
            };

            form.classList.add("loading");
            // Envia os dados com Axios
            axios.post(site_url.url + '/wp-json/legatus/v1/submit-form', submissionData)
                .then(response => {
                    alert(form.getAttribute("data-resposta") ? form.getAttribute("data-resposta") : 'Formulário enviado com sucesso!');
                    console.log(response.data);
                    form.reset(); // Limpa o formulário após o envio
                    form.classList.remove("loading");
                })
                .catch(error => {
                    alert('Ocorreu um erro ao enviar o formulário.');
                    console.error(error);
                    form.classList.remove("loading");
                });
        });
    });
});

jQuery(".list-category > li > a").click(function () {
    jQuery(this).toggleClass("act");
    jQuery(".subchilds", jQuery(this).parent()).slideToggle();

    return false;
})

jQuery(".sb").click(function () {
    return true;
})

jQuery(".has-submenu > a").click(function () {
    jQuery(this).parent().toggleClass("act");
    jQuery("> .sub-menu", jQuery(this).parent()).slideToggle();
    return false;
})

document.addEventListener('DOMContentLoaded', function() {
    const cartCountSpan = document.querySelector('.carrinho-count span');

    function updateCartCount() {
        const count = Object.keys(localStorage)
            .filter(key => key.startsWith('cart_'))
            .length;

        if(count === 0) {
            cartCountSpan.textContent = '';
        } else {
            cartCountSpan.textContent = String(count);
        }

    }

    // Atualiza imediatamente
    updateCartCount();
    // Atualiza a cada 5 segundos
    setInterval(updateCartCount, 1000);
});
